import ChevronLeft from '@mui/icons-material/ChevronLeft';
import MoreHorizontal from '@mui/icons-material/ThreeDRotation';
import Delete from '@mui/icons-material/Delete';

const Icons = {
  // accept: CheckCircle,
  // action: MoreHorizontal,
  // add: Plus,
  // admin: Command,
  // airport: MapPin,
  // bank: AccountBalance,
  // bid: Award,
  // calendar: Calendar,
  // cancel: Slash,
  // chart: BarChart,
  // charter_a_flight: FlightTakeoff,
  // check: CheckCircle,
  // content: Edit,
  // credit: Payment,
  // dashboard: BarChart,
  delete: Delete,
  // dev: Command,
  // edit: Edit,
  // find_a_flight: EventSeat,
  // flights: Send,
  // goto: ArrowRightCircle,
  left: ChevronLeft,
  // login: LogIn,
  // logout: LogOut,
  // manifest: Briefcase, // active requests
  // menu: Menu,
  // messages: MessageCircle,
  // money: DollarSign,
  more: MoreHorizontal,
  // package: Package,
  // payment: DollarSign,
  // planes: Home, // provider plane management
  // register: FileText,
  // remove: X,
  // requests: FileText,
  // right: ChevronRight,
  // save: Save,
  // search: Search,
  // send: Send,
  // settings: Settings,
  // shopping: ShoppingBag,
  // terms: FileText,
  // uncheck: Circle,
  // user: AccountCircle,
  // users: Users,
};
export default Icons;
